const KEY_CODE_VERIFIER = "9s_pkce_code_verifier";
const KEY_SESSION_EVENT = "9s_session_event";

export const BOOTSTRAP_AUTH_ME_SHELL_KEY = "9s:bootstrap:auth-me-shell";
export const BOOTSTRAP_CONFIG_SHELL_KEY = "9s:bootstrap:config-shell";

export const SESSION_CHANGED_EVENT = "9s:session-changed";

export function getAccessToken(): string | null {
  return null;
}

export function setAccessToken(_token: string): void {
  publishSessionChanged();
}

export function clearAccessToken(): void {
  clearSessionMarkers();
}

export function authFetchCredentials(): RequestCredentials {
  return "include";
}

export function publishSessionChanged(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(SESSION_CHANGED_EVENT));
  try {
    localStorage.setItem(KEY_SESSION_EVENT, String(Date.now()));
  } catch {
    /* storage can be unavailable in private browsing */
  }
}

/** Drop bootstrap shell cache so stale auth-me cannot re-mark the session authenticated after logout. */
export function clearBootstrapSessionCache(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(BOOTSTRAP_AUTH_ME_SHELL_KEY);
    sessionStorage.removeItem(BOOTSTRAP_CONFIG_SHELL_KEY);
  } catch {
    /* private mode or quota */
  }
}

export function clearSessionMarkers(): void {
  clearCodeVerifier();
  clearBootstrapSessionCache();
}

export function redirectToLogin(): void {
  try {
    clearCodeVerifier();
  } catch {
    /* sessionStorage unavailable */
  }
  if (typeof window === "undefined") return;
  const { pathname, search, origin } = window.location;
  if (pathname === "/login") {
    window.location.replace(`${origin}/login`);
    return;
  }
  const returnUrl = encodeURIComponent(`${pathname}${search}`);
  window.location.replace(`${origin}/login?returnUrl=${returnUrl}`);
}

export function getCodeVerifier(): string | null {
  try {
    return sessionStorage.getItem(KEY_CODE_VERIFIER);
  } catch {
    return null;
  }
}

export function setCodeVerifier(v: string): void {
  sessionStorage.setItem(KEY_CODE_VERIFIER, v);
}

export function clearCodeVerifier(): void {
  sessionStorage.removeItem(KEY_CODE_VERIFIER);
}
